import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const FormSectionHeading = props => (
  <Box>
    <Typography variant='formLabel' style={{paddingBottom: '0em'}}>
      {props.title}
    </Typography>
    <Typography variant='body1' style={{marginTop: '0.25em'}}>
      {props.subtitle}
    </Typography>
  </Box>
);

export default FormSectionHeading;
